import { render, staticRenderFns } from "./DatasetCustomField.vue?vue&type=template&id=459763ea&scoped=true&"
import script from "./DatasetCustomField.vue?vue&type=script&lang=js&"
export * from "./DatasetCustomField.vue?vue&type=script&lang=js&"
import style0 from "./DatasetCustomField.vue?vue&type=style&index=0&id=459763ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459763ea",
  null
  
)

export default component.exports